import { jsx as _jsx } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useIsTablet } from "@/hooks";
import { useLocation } from "@/location/hooks/useLocation";
import { Box } from "@gemini/core";
import { EnvelopeIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useFormContext } from "react-hook-form";
import { useMapContext } from "../../../contexts/MapContext";
import { SIDEBAR_WIDTH } from "@/domains/map/constants";
export const MapContactEntry = () => {
    const { t } = useI18n();
    const { toggleModal } = useContactContext();
    const { setValue } = useFormContext();
    const { isSidebarOpen } = useMapContext();
    const { isAddressPublished } = useLocation() || {};
    const isTablet = useIsTablet();
    const isProject = useIsNewBuildProject();
    const handlePress = () => {
        const newMessage = isAddressPublished
            ? t("contact.form.subject_placeholder")
            : t("contact.form.subject_placeholder_precise_address");
        setValue("message", newMessage);
        toggleModal({
            av_zone: "map",
            av_feature: "request_precise_address",
            legacyTrackingInfos: "detail-get_adress",
        });
    };
    const requestAddressLabel = isTablet
        ? t("location.map.request_precise_address_mobile")
        : t("location.map.request_precise_address_desktop");
    const requestVisitLabel = isTablet
        ? t("location.map.request_visit_mobile")
        : t("location.map.request_visit_desktop");
    const addressCtaText = isAddressPublished
        ? requestVisitLabel
        : requestAddressLabel;
    const ctaText = isProject ? t("contact.form.project.email") : addressCtaText;
    return (_jsx(Box, { position: "absolute", bottom: "spacing.32", right: "0", left: {
            "breakpoint.base": 0,
            "breakpoint.md": isSidebarOpen ? `${SIDEBAR_WIDTH}px` : 0,
        }, margin: "auto", width: "fit-content", transitionDuration: "motionDuration.300", children: _jsx(Button, { onPress: handlePress, icon: EnvelopeIcon, children: ctaText }) }));
};
